import { render, staticRenderFns } from "./setting-join-website.vue?vue&type=template&id=291dc7f1&"
import script from "./setting-join-website.vue?vue&type=script&lang=js&"
export * from "./setting-join-website.vue?vue&type=script&lang=js&"
import style0 from "./setting-join-website.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports